import { render } from "./BranchScaleComparisonBlock.vue?vue&type=template&id=f566a958&scoped=true"
import script from "./BranchScaleComparisonBlock.vue?vue&type=script&lang=js"
export * from "./BranchScaleComparisonBlock.vue?vue&type=script&lang=js"

import "./BranchScaleComparisonBlock.vue?vue&type=style&index=0&id=f566a958&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f566a958"]])

export default __exports__